module.exports = __webpack_public_path__ + "media/components/weather-icon/static/daylightrain@3-a12d4677bc20bb3fddf5bede8bfc4689.png";